/** Dashboard counters and metric tiles — always show grouping commas. */
export function formatDashboardCount(value) {
  const numeric = Number(value ?? 0);
  if (!Number.isFinite(numeric)) return '0';
  return numeric.toLocaleString('en-US');
}

/** Dashboard money metrics — dollar sign plus grouping commas. */
export function formatDashboardCurrency(value) {
  return `$${formatDashboardCount(value)}`;
}
